// src/components/EndOfDayModal/EndOfDayModal.js
import React from 'react';
import styles from './EndOfDayModal.module.css';

const EndOfDayModal = ({ dayNumber, summary, onStartNextDay, isPassingOut }) => {
  // For now, summary might be simple. Later, you can pass more detailed stats.
  const { goldEarned = 0, xpGained = 0, itemsFound = 0 } = summary || {};

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {isPassingOut ? (
          <h2 className={styles.modalTitleWarning}>You Collapsed From Exhaustion!</h2>
        ) : (
          <h2 className={styles.modalTitle}>End of Day {dayNumber}</h2>
        )}

        <div className={styles.summarySection}>
          <h3>Day Summary</h3>
          {isPassingOut && (
            <p className={styles.passOutMessage}>
              You pushed yourself too hard and passed out. You'll wake up feeling a bit drained.
            </p>
          )}
          {/* Placeholder for more detailed summary items */}
          <p>Gold Earned: {goldEarned} G</p>
          <p>Total XP Gained: {xpGained} XP</p>
          <p>Items Found: {itemsFound}</p>
          {/* You can expand this with lists of items, specific skill XP, etc. */}
        </div>

        <button onClick={onStartNextDay} className={styles.actionButton}>
          Start Next Day (Day {dayNumber + 1})
        </button>
        <p className={styles.saveNote}>Your progress will be saved.</p>
      </div>
    </div>
  );
};

export default EndOfDayModal;